<header>
  <div class="cl-3-f ji-c" style="max-height: 12%;">
    <div class="cl-1 rw-1">
      <a routerLink="/" class="home"><img src="../assets/logo.svg" alt="logo" class="home-svg"></a>
    </div>
    <div class="cl-4 rw-1" style="justify-items: center;">
      <button class="bt-m bt-blue" type="button" routerLink="/about">About me</button>
      <button class="bt-m bt-blue" type="button" routerLink="/curriculum">Curriculum</button>
      <button class="bt-m bt-blue" type="button" routerLink="/projects">Projects</button>
      <button class="bt-m bt-blue" type="button" routerLink="/contact">Contact</button>
    </div>
  </div>
</header>
